import {
	ChartColumn,
	CircleHelp,
	FileWarning,
	House,
	LogOut,
	type LucideIcon,
	Package,
	User,
	Wallet,
	Warehouse,
} from "lucide-react";

export const PORTAL_PATH = {
	Login: "/vendor/login",
	Home: "/vendor/dashboard",
	PartnerData: "/vendor/consignment-vendor-application/update",
	Contract: "/vendor/consignment-vendor-application/contract",
	Product: "/vendor/consignment-vendor-product",
	StockIn: "/vendor/consignment-stock-in-request",
	StockInCreate: "/vendor/consignment-stock-in-request/create",
	StockOut: "/vendor/consignment-stock-out",
	StockLedger: "/vendor/consignment-stock-ledger",
	Sales: "/vendor/consignment-vendor-sales",
	Disbursement: "/vendor/consignment-disbursement",
	WarningLetter: "/vendor/consignment-warning-letter",
	Notification: "/vendor/consignment-notification",
	Account: "/vendor/consignment-vendor",
} as const;

export type PortalPath = (typeof PORTAL_PATH)[keyof typeof PORTAL_PATH];

export type PortalMenuItem = {
	label: string;
	to: PortalPath;
	icon: LucideIcon;
	activePaths: PortalPath[];
	isDisabled?: boolean;
};

export const MAIN_MENU_LABEL = "MENU";
export const ACCOUNT_MENU_LABEL = "Akun";

export const MAIN_MENU_ITEMS: PortalMenuItem[] = [
	{
		label: "Beranda",
		to: PORTAL_PATH.Home,
		icon: House,
		activePaths: [PORTAL_PATH.Home, PORTAL_PATH.PartnerData],
	},
	{
		label: "Produk",
		to: PORTAL_PATH.Product,
		icon: Package,
		activePaths: [PORTAL_PATH.Product],
	},
	{
		label: "Stok",
		to: PORTAL_PATH.StockIn,
		icon: Warehouse,
		activePaths: [
			PORTAL_PATH.StockIn,
			PORTAL_PATH.StockOut,
			PORTAL_PATH.StockLedger,
		],
	},
	{
		label: "Penjualan",
		to: PORTAL_PATH.Sales,
		icon: ChartColumn,
		activePaths: [PORTAL_PATH.Sales],
	},
	{
		label: "Pencairan",
		to: PORTAL_PATH.Disbursement,
		icon: Wallet,
		activePaths: [PORTAL_PATH.Disbursement],
	},
	{
		label: "Surat peringatan",
		to: PORTAL_PATH.WarningLetter,
		icon: FileWarning,
		activePaths: [PORTAL_PATH.WarningLetter],
	},
];

export const BOTTOM_NAV_ITEMS: PortalMenuItem[] = MAIN_MENU_ITEMS.filter(
	(menuItem) =>
		menuItem.to === PORTAL_PATH.Home ||
		menuItem.to === PORTAL_PATH.Product ||
		menuItem.to === PORTAL_PATH.Sales,
);

export const ACCOUNT_MENU_ITEMS: PortalMenuItem[] = [
	{
		label: "Akun saya",
		to: PORTAL_PATH.Account,
		icon: User,
		activePaths: [PORTAL_PATH.Account, PORTAL_PATH.Contract],
	},
	{
		label: "Bantuan",
		to: PORTAL_PATH.Account,
		icon: CircleHelp,
		activePaths: [],
		isDisabled: true,
	},
];

export const LOGOUT_LABEL = "Keluar";
export const LOGOUT_ICON = LogOut;

export const isMenuItemActive = (
	menuItem: PortalMenuItem,
	currentPathname: string,
) =>
	menuItem.activePaths.some(
		(activePath) =>
			currentPathname === activePath ||
			currentPathname.startsWith(`${activePath}/`),
	);
